import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Can } from '@morningtrain/react-auth'
import useTranslatedCurrentMonth from 'support/hooks/use-translated-current-month'
import { Model, WhenModel } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import * as Displays from 'support/displays'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import useTranslatedShortLastMonth from 'support/hooks/use-translated-short-last-month'
import useCurrentWeekNumber from 'support/hooks/use-current-week-number'
import useLastWeekNumber from 'support/hooks/use-last-week-number'
import { Percentage as PercentageDisplay } from '@morningtrain/react-displays'

export default function WageRatioSummaryDashboardWidget ({ tablet = false }) {
  const currentMonth = useTranslatedCurrentMonth()
  const shortLastMonth = useTranslatedShortLastMonth()
  const currentWeek = useCurrentWeekNumber()
  const lastWeek = useLastWeekNumber()
  return (
    <Can permission="api.dashboard.wage_ratio_summary">
      <Widget>
        <Translator namespace="dashboard.wage_ratio_summary">
          <UI.Card paddingBottom={false}>

            <UI.CardHeader>
              <UI.Text color="primary" weight="medium" size="lg">
                <Translation name="title"/>
              </UI.Text>
            </UI.CardHeader>

            <div className="flex flex-col flex-grow flex-shrink">
              <Model resourceName="dashboard" operationName="wage_ratio_summary">
                <SelectedDepartmentFilter/>
                <WhenModel>

                  <UI.WithSubtitle subtitle={tablet ? null : (
                    <>
                      <UI.Text size="xs" className="mr-3">
                        <Translation name="generic.avg_overall"/>
                        <span>: </span>
                        <Displays.WageRatio name="last_year_total"/>
                      </UI.Text>
                      <UI.Text size="xs" className="">
                        <Translation name="approved"/>
                        <span>: </span>
                        <PercentageDisplay name="target" decimals={2}/>
                      </UI.Text>
                    </>
                  )}
                  >
                    <UI.Text weight="medium" size="3xl">
                      <Displays.WageRatio
                        name="today_total"
                      />
                    </UI.Text>
                  </UI.WithSubtitle>

                  <SmartviewContentSeparator/>

                  <SmartviewTextGroup highlight={!tablet} highlightSize="card">

                    <SmartviewText>
                      <UI.SpaceBetween>
                        <UI.Text size="base">
                          <Translation name="generic.week_number" data={{ week: currentWeek }}/>
                        </UI.Text>

                        <UI.Text weight="medium" size="base" align="right">
                          <Displays.WageRatio name="this_week_total"/>
                        </UI.Text>

                      </UI.SpaceBetween>
                    </SmartviewText>

                    <SmartviewText>
                      <UI.SpaceBetween>
                        <UI.Text size="base">
                          {currentMonth}
                        </UI.Text>

                        <UI.Text weight="medium" size="base" align="right">
                          <Displays.WageRatio name="this_month_total"/>
                        </UI.Text>

                      </UI.SpaceBetween>
                    </SmartviewText>

                  </SmartviewTextGroup>

                  {tablet ? <div className="mb-6"/> : (
                    <UI.HorizontalList border className="my-4 pt-6 -mx-6">

                      <UI.WithSubtitle subtitle={(
                        <UI.Text weight="medium" color="black">
                          <Displays.Percentage
                            decimals={0}
                            name="progress_since_last_month"
                            badBelow={0}
                            showPlusIfPositive
                          />
                        </UI.Text>
                      )}
                      >
                        <UI.Text uppercase size="xs" color="gray">
                          {shortLastMonth}
                        </UI.Text>
                      </UI.WithSubtitle>

                      <UI.WithSubtitle subtitle={(
                        <UI.Text weight="medium" color="black">
                          <Displays.Percentage
                            decimals={0}
                            name="progress_since_last_week"
                            badBelow={0}
                            showPlusIfPositive
                          />
                        </UI.Text>
                      )}
                      >
                        <UI.Text uppercase size="xs" color="gray">
                          <Translation name="generic.week_number" data={{ week: lastWeek }}/>
                        </UI.Text>
                      </UI.WithSubtitle>

                      <UI.WithSubtitle subtitle={(
                        <UI.Text weight="medium" color="black">
                          <Displays.Percentage
                            decimals={0}
                            name="progress_since_avg_month"
                            badBelow={0}
                            showPlusIfPositive
                          />
                        </UI.Text>
                      )}
                      >
                        <UI.Text uppercase size="xs" color="gray">
                          <Translation name="generic.avg_month"/>
                        </UI.Text>
                      </UI.WithSubtitle>

                    </UI.HorizontalList>
                  )}

                </WhenModel>
              </Model>
            </div>

          </UI.Card>
        </Translator>
      </Widget>
    </Can>
  )
}
